// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		/* Timeline Quad Functionality */
		if(document.getElementsByClassName("timeline")[0]){
			let timelineTabs = document.querySelectorAll(".timeline__lineTabs li");

			/* let FitemHeight = document.querySelector(".timeline__item:first-of-type").clientHeight;
			
			let itemContent = document.getElementsByClassName("timeline__content")[0];
			itemContent.setAttribute("style", `height:${FitemHeight}px`) */
			
			for(let c = 0; c < timelineTabs.length; c++){
				timelineTabs[c].addEventListener('click', function () {

					let currentTabDataRef = this.getAttribute("data-ref");
					document.querySelectorAll(".timeline [data-ref]").forEach(item => { item.classList.remove('active'); })
					document.querySelectorAll(` [data-ref="${currentTabDataRef}"] `).forEach(item => { item.classList.add('active'); })

					if (window.innerWidth <= 1025) {
						document.querySelectorAll(`.timeline__item[data-ref="${currentTabDataRef}"] `).forEach(item => { 
							let itemHeight = item.clientHeight;
							let itemContent = document.getElementsByClassName("timeline__content")[0];
							itemContent.setAttribute("style", `height:${itemHeight}px`)
						})
					}

				});
			}
		}
		/* END */

		/* Search a <span> tag in <h2> headlines to add style */
		let allh2 = document.querySelectorAll(' h2 ');
		for(let z = 0; z < allh2.length; z++){
			if( allh2[z].getElementsByTagName('span')[0] ){
				allh2[z].style.marginLeft = "85px";
			}
		}
		/* END */

		/* Open and Close Menu */
		let openMenuButton = document.getElementById('menuButton');
		let closeMenuButton = document.getElementById('closeMenu');
		let menuSection = document.getElementById('menu');

		openMenuButton.addEventListener('click', () => { 
			menuSection.classList.add("open");
		});
		closeMenuButton.addEventListener('click', () => { 
			menuSection.classList.remove("open");
		});
		/* END */


		/* Add span to all btn */
		setTimeout(function(){
			let btn = document.querySelectorAll('.btn');
			btn.forEach(btn => {
				btn.innerHTML = btn.innerText + "<span></span>";
			});
			let btn_white = document.querySelectorAll('.btn_white');
			btn_white.forEach(btn_white => {
				btn_white.innerHTML = btn_white.innerText + "<span></span>";
			});
		}, 1000);
			
		/* END */

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	$('.js-expand-cta').click(function (event) {
		event.preventDefault();
		if($(this).hasClass("open")) {
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(".expand-copy").slideToggle();
	});
	
}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
		
	const header = document.getElementById('header');
	const logo = document.querySelector('.header__logo img');
    if (header && logo) {
        const logoUrl = st > 40 ? '/assets/images/svg/logo.svg' :'/assets/images/svg/logo.svg';
			if (st > 40 && !header.classList.contains('down')) {
				header.classList.add('down');
				logo.setAttribute('src', logoUrl);
			} else if (st <= 40 && header.classList.contains('down')) {
				header.classList.remove('down');
			}
			logo.setAttribute('src', logoUrl);
		}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

// Main Site Language
document.querySelectorAll(".js-language-span").forEach(languageSpan => {
	languageSpan.addEventListener("click", function(e){
		console.log(languageSpan.getAttribute("value"));
		changeLanguage(languageSpan.getAttribute("value"));
	});
});

(function() {
	
	// Amenities Read More
	if (window.innerWidth <= 640) {
		let amenitiesList = document.querySelectorAll('.js-amenitiesMore ul');
		
		if (amenitiesList && amenitiesList.length == 1) {
			amenitiesList = amenitiesList[0];
	
			if (amenitiesList.childNodes.length > 4) {
				const amenitiesEach = amenitiesList.getElementsByTagName('li');
		
				let listHeight = 0;
				for (let i = 0; i < 4; i++) {
					listHeight += amenitiesEach[i].getBoundingClientRect().height + 14;
				}
				listHeight += 30;
		
				amenitiesList.style.setProperty('--innerHeight', `${listHeight}px`);
				
				amenitiesList.insertAdjacentHTML('afterend', '<button id="read-more-amenities" type="button" class="btn_white" aria-label="Read More Amenities">Read More</button>');
				document.getElementById('read-more-amenities').addEventListener('click', function() {
					amenitiesList.classList.add('full');
					this.remove();
				});
			}
		}
	}

	// Menu Categories
	const menuTabs = document.querySelectorAll(".menu-categories_tabs [data-menu]");
	let menuTabActive = menuTabs[0];
	let menuItemActive = document.querySelector(".menu-categories_item");

	menuTabs && menuTabs.forEach(tab => tab.addEventListener("click", function() {
		menuTabActive.classList.remove('active');
		menuItemActive.classList.remove('active');
		
		document.getElementById(this.dataset.menu).classList.add('active');
		menuItemActive = document.getElementById(this.dataset.menu);

		this.classList.add('active');
		menuTabActive = this;
	}));

})();